import script from "./ViewViolationParameters.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewViolationParameters.vue?vue&type=script&setup=true&lang=js"

import "./ViewViolationParameters.vue?vue&type=style&index=0&id=0a11f136&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a11f136"]])

export default __exports__